import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  X3ExperiencesInitModel,
  X3ExperiencesInitVariables,
  X3ExperiencesModel,
  X3ExperiencesVariables,
} from '../../../../../models/email-template/x3-experiences.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-x3-experiences',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './x3-experiences.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './x3-experiences.component.scss'
})
export class X3ExperiencesComponent extends BaseComponent implements OnInit {
  @Input() block: X3ExperiencesModel = new X3ExperiencesInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new X3ExperiencesInitVariables()
    }
  }

  //placeholders:
  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image3Placeholder: string = 'Third Image';
  image1HrefPlaceholder: string = 'Enter First Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Second Image Redirect Link';
  image3HrefPlaceholder: string = 'Enter Third Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  image3AltPlaceholder: string = 'Enter Third Image Alt Text';
  heading1Placeholder: string = 'Enter First Heading';
  heading2Placeholder: string = 'Enter Second Heading';
  heading3Placeholder: string = 'Enter Third Heading';
  ctaLink1Placeholder: string = 'Enter First CTA Link';
  ctaText1Placeholder: string = 'Enter First CTA Text';
  ctaLink2Placeholder: string = 'Enter Second CTA Link';
  ctaText2Placeholder: string = 'Enter Second CTA Text';
  ctaLink3Placeholder: string = 'Enter Third CTA Link';
  ctaText3Placeholder: string = 'Enter Third CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof X3ExperiencesVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof X3ExperiencesVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
